module.exports = __webpack_public_path__ + "static/media/about-us.5564752c.svg";